import {IsoDate} from "../../pseudo-types/DateTypes";
import {Pair, PairOf} from "../../types/GenericTypes";

export enum TimeFrame {
    FYTD = "FYTD",
    LFY = "LFY",
    YTD = "YTD",
    CUSTOM = "CUSTOM"
}

export type TimeFrameRanges = ReadonlyArray<TimeFrameRange>;

export class TimeFrameRange {

    private constructor(public readonly timeFrame: TimeFrame,
                        private readonly start: IsoDate,
                        private readonly end: IsoDate) {
    }

    public matches(range: Pair<IsoDate>): boolean {
        return (range[0] === this.start) && (range[1] === this.end);
    }

    public get range(): Pair<IsoDate> {
        return PairOf(this.start, this.end);
    }

    public isEqualTo(other: TimeFrameRange): boolean {
        if (this.timeFrame !== other.timeFrame) {
            return false;
        } else {
            return this.matches(other.range);
        }
    }

    public static of(timeFrame: TimeFrame, start: IsoDate, end: IsoDate): TimeFrameRange {
        return new TimeFrameRange(timeFrame, start, end);
    }
}
